import { utils } from '@ps/web-poker-tile-mappers';
import type { RawButtonProps } from '@ps/web-shared-components';
import { StarsButton as Button } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';

import { useMTTHandleRegister } from '../../../../hooks/';
import type { Tournament } from '../../../../types/MTT';

import { TXTCLI_Register__toTournament } from './Buttons.messages.json';
import styles from './Buttons.scss';
import LobbyButton from './LobbyButton/LobbyButton';

interface Props {
  tournament: Tournament;
  classes?: {
    root?: string;
    register?: string;
    lobby?: string;
  };
  size?: RawButtonProps['size'];
  showLobbyButton?: boolean;
  showRegisterButton?: boolean;
}

const Buttons: React.FC<Props> = ({
  tournament,
  classes = { root: '', register: '', lobby: '' },
  size = 'small',
  showLobbyButton,
  showRegisterButton = true
}) => {
  const isRegistrationOpen = utils.mttUtils.isRegOpen(tournament.legacyStatus);
  const handleRegisterClick = useMTTHandleRegister(tournament?.id);

  return (
    <div
      className={classNames(
        styles.buttons,
        { [styles.empty]: !isRegistrationOpen && !showLobbyButton },
        classes.root
      )}
    >
      {showRegisterButton && isRegistrationOpen && (
        <Button
          variant="primary"
          disabled={!tournament.isEnabled}
          translation={TXTCLI_Register__toTournament}
          size={size}
          onClick={handleRegisterClick}
          className={classNames(styles.button, classes.register)}
        />
      )}
      {showLobbyButton && (
        <LobbyButton
          tournament={tournament}
          size={size}
          className={classNames(styles.button, classes.lobby)}
        />
      )}
    </div>
  );
};

export default Buttons;
